PJQ.collections.actionItems = {};

PJQ.models.actionItems = {};

PJQ.views.actionItems = {};

//Routes
PJQ.modules.actionItems = {
    routes: [
        {
            route: 'projects/:projectId/actionitems',
            name: 'actionItems',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "actionitems");
            }
        },
        {
            route: 'projects/:projectId/actionitems/:actionItemId',
            name: 'actionItem',
            callback: function (projectId, actionItemId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "actionitems", {
                    actionItemId: parseInt(actionItemId)
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.actionItems.routes);